<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.ecomWarehouseStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_ecomWarehouseStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="{
                  pageType: 'detail',
                  params: { code: row.ecomWarehouseCode },
                  query: { ecomWarehouseNo: row.ecomWarehouseNo },
                }"
              >
                {{ $l('INDEX.btn_tips_view') || '查看' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                divided
                v-if="allow('M')"
                v-show="row.ecomWarehouseStatus === 'Y'"
                :command="{
                  pageType: 'edit',
                  params: { code: row.ecomWarehouseCode },
                  query: { ecomWarehouseNo: row.ecomWarehouseNo },
                }"
              >
                {{ $l('INDEX.btn_tips_edit') || '编辑' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-delete"
                v-if="allow('D')"
                v-show="row.ecomWarehouseStatus === 'Y'"
                :command="{
                  pageType: 'del',
                  params: { code: row.ecomWarehouseCode },
                }"
              >
                {{ $l('INDEX.btn_tips_del') || '删除' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:createdBy="{ row }">
        <div style="line-height: 17px;">
          <div>{{ row.createByName }}</div>
          <div>{{ row.createDate }}</div>
        </div>
      </template>
      <template v-slot:modifiedBy="{ row }">
        <div style="line-height: 17px;">
          <div>{{ row.modifyByName }}</div>
          <div>{{ row.modifyDate }}</div>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    handleCommand(command) {
      const { pageType, params = {}, query = {} } = command
      console.log(pageType)
      switch (pageType) {
        case 'detail':
        case 'edit':
          this.openEditPage({ pageType, params, query })
          break
        case 'del':
          this.del(params['code'])
          break
        default:
          return
      }
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-warehouse-detail',
        params: { ...params, pageType },
        query,
      })
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomWarehouseDelApi({ ecomWarehouseCode: code }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
